import { apiUri } from '../../constants/Constants';
import { client } from '../axios/axiosClient';
import { FeatureFlagData } from '../types/FeatureFlag';

const getFeatureFlags = async () => {
  return await client.get(apiUri.getFeatureFlags).then((value: FeatureFlagData) => {
    return value.data;
  });
};

export default getFeatureFlags;
